import React from 'react'
const TabNavItem = ({id,title,icon,iconfill,activeTab,setActiveTab}) => {
    const handleClick = () => {
        setActiveTab(id);
    }
    return ( 
        <li onClick={handleClick} className={activeTab === id ? "nav-item active":"nav-item"}>
        <div className={activeTab === id ?'nav-link active text-active-primary me-6':'nav-link text-active-primary me-6'}>{title}</div>
        
    </li>
     );
}
 
export default TabNavItem;